import AppLoadingView from './app-loading-view'

export default AppLoadingView
